import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { AzureCosmosDbMongoDbApiLinkedService } from 'app/model/linkedservice/azure-cosmos-db-mongodb-api.linkedservice';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';
import { format, sanitizeAndFormatString, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { type IVersioningDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cosmosMongo.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.CosmosDbMongoApi_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.CosmosDbMongoApi_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureCosmosDbMongoDbApiLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureCosmosDbMongoDbApiDataset extends TabularTypeDataset implements IVersioningDataset {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    public static VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: AzureCosmosDbMongoDbApiDataset, database: string) => {
                if (__IS_FABRIC_DPE__ && stringIsNullOrEmpty(database)) {
                    return [
                        {
                            context: dataset,
                            messageType: 'missing',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.RequiredTemplate,
                                    stringResources.Database
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version: string = __IS_FABRIC_DPE__ ? '1.1' : undefined;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
